import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import DatetimePicker from 'vuetify-datetime-picker'
import dayjs from 'dayjs'

Vue.use(DatetimePicker)
Vue.use(dayjs)

import '@babel/polyfill'


import axios from 'axios'
import './plugins/dayjs'

Vue.prototype.axios = axios

axios.defaults.baseURL = 'https://api.rubenjungbluth.com/api/'
// axios.defaults.baseURL = 'https://rj-api.rolabs.dev/api/'
if (window.location.search.indexOf("token") > -1){
localStorage.setItem('token',window.location.search.split("=")[1])
}
const userToken = localStorage.getItem('token')

Vue.config.productionTip = false

if (userToken) {
  axios.defaults.headers.common['Authorization'] = 'bearer ' + userToken;
}
  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount('#app')



